export default __webpack_public_path__ + "static/media/img-0430-hungary-full-face.67dc93af.png";